import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
//import cancelIcon from "../../img/icon/icon-cancel.svg";

import { ChangeMobileFormat, addThousandPoint, unescapeHtml,PassedMonthsCode, escapeHtml,isNull,removeThousandFloat,LoginAfterCheckLogin } from "../../components/common/Common";
import "../../css/style.css";

//청구서 내역
const InvoiceSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const branch_bizcode = localStorage.getItem('branch_bizcode').replaceAll(/-/g,'');
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const newClassData = {cl_idx:0,cl_name:"",sm_idx:0,sm_name:"",cl_type:1,iv_idx:0,iv_price:0,iv_reason:"",iv_message:""};
  const [varInvoiceInfo,setInvoiceInfo] = useState(newClassData);
  
  const [varSemesterList,setSemesterList] = useState([]);
  const [varClassList,setClassList] = useState([]);
  const [varSelectClassList,setSelectClassList] = useState([]);
  const [varClassStudentList,setClassStudentList] = useState([]);

  const [varSemesterIndex,setSemesterIndex] = useState(0);
  const [varClassIndex,setClassIndex] = useState(0);
  const [varSearchName,setSearchName] = useState("");

  const [varSelectChildrenList,setSelectChildrenList] = useState([]);

  //학기내역 가져오기
  const GetInvoiceList = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_invoice_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1){ 
        //학기목록
        setSemesterList(datas.semesters);
        //클래스 목록
        setClassList(datas.classes);
      } else {
        setClassList([]);
      }
    });
  }

  //청구서 목록
  const GetInvoiceChildrenList = async() => {
    const sendData = {branch_idx:branch_idx,sm_idx:varSemesterIndex,cl_idx:varClassIndex,searchName:varSearchName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_invoice_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //학기에 해당하는ㄴ 클래스목록
        //console.log(varClassList);
        const selClassList = varClassList.filter(el=>el.sm_idx === varSemesterIndex);
        //console.log(selClassList);
        setSelectClassList(selClassList);

        //원생목록
        const invoices = datas.invoices;
        const childrensList = datas.childrens;

        if(varClassIndex === 0) {
          setClassStudentList([]);
          newClassData.sm_idx = varSemesterIndex;
          newClassData.cl_idx = 0;
          setInvoiceInfo(newClassData);
          //선택취소로
          setClassStudentList([]);
          return;
        }

        //원생별로 청구서 발송유무 점검
        for(let i=0; i < childrensList.length; i++) {
          let ch_idx = childrensList[i].ch_idx;
          const findIndex = invoices.findIndex(el=>el.ch_idx===ch_idx && el.cl_idx===varClassIndex);
          //console.log(ch_idx,varClassIndex,findIndex,invoices[findIndex]);
          if(findIndex === -1){
            childrensList[i]['ivc_idx'] = 0;
            childrensList[i]['ivc_status'] = 0;
            childrensList[i]['invoice'] = 0;
          } else {
            childrensList[i]['ivc_idx'] =invoices[findIndex].ivc_idx;
            childrensList[i]['ivc_status'] =invoices[findIndex].ivc_status;
            childrensList[i]['invoice'] = invoices[findIndex].ivc_idx;
          }
          //console.log('aaaa',childrensList[i]['invoice']);
        }
        console.log(childrensList);
        setClassStudentList(childrensList);

        //청구서 정보 - 첫번쨰 원생으로부터 청구서 정보 호출
        const newData = varClassList.find(el=>el.cl_idx===varClassIndex);
        setInvoiceInfo(newData);

      } else {
        newClassData.sm_idx = varSemesterIndex;
        newClassData.cl_idx = varClassIndex;
        newClassData.cl_type = 1;
        setInvoiceInfo(newClassData);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //청구서를 발송할 원생 목록 초기화
    localStorage.setItem('selectChildrenList','');
    GetInvoiceList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(varSemesterIndex,varClassIndex);
    if(varSemesterIndex === 0) {
      newClassData.sm_idx = varSemesterIndex;
      newClassData.cl_idx = 0;
      newClassData.cl_type = 1;
      setInvoiceInfo(newClassData);
      setSelectClassList([]);
      setClassStudentList([]);
    } else {
      GetInvoiceChildrenList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSemesterIndex,varClassIndex]);

  //학기 선택
  const onSelectSemesterHandler = (e) => {
    const sm_idx = Number(e.currentTarget.value);
    setSemesterIndex(sm_idx); //학기지정
    setClassIndex(0); //클래스 초기화
    if(sm_idx === 0) {
      newClassData.sm_idx = varSemesterIndex;
      newClassData.cl_idx = varClassIndex;
      newClassData.cl_type = 1;
      const findIndex = varClassList.findIndex(el=>el.cl_idx===varClassIndex);
      if(findIndex > -1) setInvoiceInfo(varClassList[findIndex]);
      else setInvoiceInfo(newClassData);
    } else {
      //선택돈 학기에 맞는 클래스만 표시
      const selClassList = varClassList.filter(el=>el.sm_idx === varSemesterIndex);
      setSelectClassList(selClassList);
      setInvoiceInfo({...varInvoiceInfo,sm_idx:sm_idx,cl_idx:0});
    }
  }

  //클래스 선택
  const onSelectClassHandler = (e) => {
    const cl_idx = Number(e.currentTarget.value);
    setClassIndex(cl_idx);
    if(cl_idx === 0) {
      newClassData.sm_idx = varSemesterIndex;
      newClassData.cl_idx = varClassIndex;
      newClassData.cl_type = 1;
      const findIndex = varClassList.findIndex(el=>el.cl_idx===varClassIndex);
      if(findIndex > -1) setInvoiceInfo(varClassList[findIndex]);
      else setInvoiceInfo(newClassData);
    } else {
      setInvoiceInfo({...varInvoiceInfo,cl_idx:cl_idx});
    }
  }

  //검색명
  const onChangeSearchNameHandler = (e) => {
    const sname = e.currentTarget.value;
    setSearchName(sname);
  }

  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    if(varSemesterIndex === 0) {
      alert('학기를 먼저 선택하세요.'); return false;
    } else if(varClassIndex === 0) {
      alert('클래스를 먼저 선택하세요.'); return false;
    }
    GetInvoiceChildrenList();
  }

  //정보변경
  const onChangeInputHandler = (e) => {
    const {name,value} = e.target;
    if(name === "iv_reason" || name === "iv_message") {
      setInvoiceInfo({...varInvoiceInfo,[name]:escapeHtml(value)});
    } else if(name === "iv_price") {
      const svalue = removeThousandFloat(value);
      setInvoiceInfo({...varInvoiceInfo,[name]:Number(svalue)});
    } else {
      setInvoiceInfo({...varInvoiceInfo,[name]:value});
    }
  }

  //청구서를 발송할 원생 선택
  const onSelectedChildrenHandler = (e,ch_idx) => {
    if(varSemesterIndex === 0 || varClassIndex === 0) {
      alert('청구서를 발송하기위하여 학기와 클래스를 먼저 선택하세요.'); return false;
    }
    const ichecked = Number(e.currentTarget.checked);
    if(ichecked) {
      if(!varSelectChildrenList.includes(ch_idx)) {
        setSelectChildrenList(varSelectChildrenList.concat(ch_idx));
      }
    } else {
      if(varSelectChildrenList.includes(ch_idx)) {
        const copyList = varSelectChildrenList.filter(el=>el !== ch_idx);
        setSelectChildrenList(copyList);
      }
    }
  }

  //청구서 발송 -- 청구정보 저장
  const onSaveInvoiceHandler = async(e) => {
    if(varSemesterIndex === 0) {
      alert('청구서를 발송할 학기를 먼저 선택하세요.'); return false;
    } else if(varClassIndex === 0) {
        alert('청구서를 발송할 클래스를 먼저 선택하세요.'); return false;
    } else if(varInvoiceInfo.iv_price === 0){
      alert('청구금액을 먼저 입력하세요.'); return false;
    } else if(isNull(varInvoiceInfo.iv_reason)){
      alert('청구사유를 먼저 입력하세요.'); return false;
    } else if(isNull(varInvoiceInfo.iv_message)) {
      alert('안내메시지를 먼저 입력하세요.'); return false;
    } else if(varInvoiceInfo.iv_price < 100){
      alert('청구금액은 100원 이상이어야 합니다.'); return false;
    }
    if(varSelectChildrenList.length === 0) {
      alert('청구서를 발송할 원생을 먼저 선택하세요.'); return false;
    }

    //청구서를 발송할 원생 목록을 로컬스토리지에 저장
    localStorage.setItem('selectChildrenList',JSON.stringify(varSelectChildrenList));

    const sendData = {invInfo:varInvoiceInfo,sm_idx:varSemesterIndex,cl_idx:varClassIndex};
    console.log(sendData);

    if(!window.confirm('청구서를 발송하시겠습니까?')) return false;

    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_invoice_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const iv_idx = datas.iv_idx;
        SendAfterUpdateInvoice(iv_idx);
      } else {
        alert(datas.message);
      }
    });
  }

  //청구서 저장 - 원생별 청구서 저장
  const SendAfterUpdateInvoice = async(iv_idx) => {
    //선택된 원생정보 취합
    const newList = [];
    for(let i=0;i<varSelectChildrenList.length;i++) {
      let selIndex = varSelectChildrenList[i];
      let selData = varClassStudentList.find(el=>el.ch_idx === selIndex);
      newList.push(selData);
    }

    const sendData = {iv_idx:iv_idx,bizcode:branch_bizcode,invInfo:varInvoiceInfo,invChildrens:newList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_invoice_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate(`/Branch/InvoiceSending/${iv_idx}`);
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'청구서 발송'} varBackString={"none"}/>
      <div className="vh-content-body">
        <div className="payment-wrap">
          <div className="center-wrap">
          <div className="select-wrap">
							<label>학기 선택</label>
							<select name="sm_idx" value={varSemesterIndex} onChange={e=>onSelectSemesterHandler(e)}>
								<option value={0}>전체 학기</option>
                {varSemesterList.map((semester,i) => (
                  <option key={'semester_'+i} value={semester.sm_idx}>{semester.sm_name}</option>
                ))}
							</select>
							<label style={{marginTop:"10px"}}>클래스 선택</label>
							<select name="cl_idx" value={varClassIndex} onChange={e=>onSelectClassHandler(e)}>
								<option value={0}>전체 클래스</option>
                {varSelectClassList.map((classes,i) => (
                  <option key={'classes_'+i} value={classes.cl_idx}>{classes.cl_name}</option>
                ))}
							</select>
						</div>
            <div className="search-wrap st03">
              <div className="search-inp-wrap">
                <input type="text" name="search_name" className="search-input" placeholder="원생명, 학부모명으로 검색" value={varSearchName} onChange={e=>onChangeSearchNameHandler(e)}/>
                <button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
              </div>
              <div className="search-con">
                {varClassStudentList.map((child,i)=>(
                  <div key={'child_'+i}>
                    <p>
                      <input type="checkbox" name="checked" checked={varSelectChildrenList.length && varSelectChildrenList.includes(child.ch_idx)} onChange={e=>onSelectedChildrenHandler(e,child.ch_idx)}/>&nbsp;
                      {child.mem_name} {ChangeMobileFormat(child.mem_mobile)} 
                      <span> 👼🏻[{child.ch_name}({PassedMonthsCode(child.ch_birthday)})]</span>
                    </p>
                    <span>{child.ivc_status===2?"발송완료":"미발송"}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="con">
							<div className="input-line">
								<p>청구 금액</p>
								<input type="text" name="iv_price" value={addThousandPoint(varInvoiceInfo.iv_price)} onChange={e=>onChangeInputHandler(e)}/>
							</div>
							<div className="input-line">
								<p>청구 사유</p>
								<input type="text" name="iv_reason" value={unescapeHtml(varInvoiceInfo.iv_reason)} onChange={e=>onChangeInputHandler(e)}/>
							</div>
							<div className="input-line">
								<p>안내 메시지</p>
								<textarea name="iv_message" value={unescapeHtml(varInvoiceInfo.iv_message)} placeholder="안내 메시지를 입력하세요" onChange={e=>onChangeInputHandler(e)}/>
							</div>
						</div>
            <div className="form-contoller bt-btn">
							<Link to={'/MainBranch'} className="form-contoller-btn btn-no" style={varClassIndex>0?{width:"48%"}:{width:"100%"}}>취소</Link>
							{varClassIndex>0?<button className="form-contoller-btn btn-yes" onClick={e=>onSaveInvoiceHandler(e)}>확인</button>:null}
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default InvoiceSet;